import { isNil } from 'lodash';
import { FormContent, FormConverter } from '~frontend-common/form-converters/form-converter';

export class PhoneNumberFormConverter extends FormConverter<string> {
  // Output format: +15553334444
  public convertFormContent(formContent: string): string {
    if (isNil(formContent)) return;

    // remove any non-number characters
    formContent = formContent.replace(/\D/g, '');

    // remove the leading 1 if present to make it easier to validate length
    if (formContent.startsWith('1')) {
      formContent = formContent.slice(1);
    }

    // don't add +1 if the phone is not complete (area code + phone number = 10 numbers)
    if (formContent.length < 10) {
      return undefined;
    }

    // add the country code
    return `+1${formContent}`;
  }

  public convertObject(value: string): FormContent {
    if (isNil(value)) return '';

    // remove any non-number characters
    value = value.replace(/\D/g, '');

    // remove leading 1 if length is more than 10
    if (value.length > 10 && value.startsWith('1')) {
      value = value.slice(1);
    }

    return value;
  }
}
